/*eslint-disable @typescript-eslint/no-explicit-any*/
type APIEndpointConfig = {
    name: string;
    region: string;
    endpoint: string;
};
export type AWSConfigOptions = {
    baseAPIUrl: string;
    apiGatewayEndpoints: APIEndpointConfig[];
    cognito: {
        REGION: string;
        USER_POOL_ID: string;
        APP_CLIENT_ID: string;
        IDENTITY_POOL_ID: string;
    };
};

const stage = window.REACT_APP_NODE_ENV;

let config: AWSConfigOptions;
switch (stage) {
    case 'production':
        config = {
            baseAPIUrl: 'https://api.helloself.com/',
            apiGatewayEndpoints: [
                {
                    name: 'partners-read',
                    region: 'eu-west-1',
                    endpoint: 'https://api.helloself.com/partners-read/',
                },
                {
                    name: 'partners-write',
                    region: 'eu-west-1',
                    endpoint: 'https://api.helloself.com/partners-write/',
                },
                {
                    name: 'referral',
                    region: 'eu-west-1',
                    endpoint: 'https://api.helloself.com/referral/',
                },
                {
                    name: 'files',
                    region: 'eu-west-1',
                    endpoint: 'https://api.helloself.com/files/',
                },
                {
                    name: 'expert',
                    region: 'eu-west-1',
                    endpoint: 'https://api.helloself.com/expert/',
                },
                {
                    name: 'messaging-v2',
                    region: 'eu-west-1',
                    endpoint: 'https://api.helloself.com/messaging-v2/',
                },
                {
                    name: 'payments',
                    region: 'eu-west-1',
                    endpoint: 'https://api.helloself.com/payments/',
                },
            ],
            cognito: {
                REGION: 'eu-west-1',
                USER_POOL_ID: 'eu-west-1_svqaoQH8Y',
                APP_CLIENT_ID: '7lts9a2bc11g61iremq39nv99b',
                IDENTITY_POOL_ID: 'eu-west-1:4f8c9b0d-44c4-4d8d-92bc-4e2651c5ef4a',
            },
        };
        break;
    case 'staging':
        config = {
            baseAPIUrl: 'https://api.test-helloself.com/',
            apiGatewayEndpoints: [
                {
                    name: 'partners-read',
                    region: 'eu-west-1',
                    endpoint: 'https://api.test-helloself.com/partners-read/',
                },
                {
                    name: 'partners-write',
                    region: 'eu-west-1',
                    endpoint: 'https://api.test-helloself.com/partners-write/',
                },
                {
                    name: 'referral',
                    region: 'eu-west-1',
                    endpoint: 'https://api.test-helloself.com/referral/',
                },
                {
                    name: 'files',
                    region: 'eu-west-1',
                    endpoint: 'https://api.test-helloself.com/files/',
                },
                {
                    name: 'expert',
                    region: 'eu-west-1',
                    endpoint: 'https://api.test-helloself.com/expert/',
                },
                {
                    name: 'messaging-v2',
                    region: 'eu-west-1',
                    endpoint: 'https://api.test-helloself.com/messaging-v2/',
                },
                {
                    name: 'payments',
                    region: 'eu-west-1',
                    endpoint: 'https://api.test-helloself.com/payments/',
                },
            ],
            cognito: {
                REGION: 'eu-west-1',
                USER_POOL_ID: 'eu-west-1_Owth3qCIL',
                APP_CLIENT_ID: '2me38jsff0c9ma9n343l1h4v5t',
                IDENTITY_POOL_ID: 'eu-west-1:3fcb90a9-b34b-4407-b010-dfe9f0a2a18d',
            },
        };
        break;
    case 'local':
    case 'test':
    case 'development':
    default:
        config = {
            baseAPIUrl: 'https://api.dev-helloself.com/',
            apiGatewayEndpoints: [
                {
                    name: 'partners-read',
                    region: 'eu-west-1',
                    // endpoint: 'http://127.0.0.1:8001/',
                    endpoint: 'https://api.dev-helloself.com/partners-read/',
                },
                {
                    name: 'partners-write',
                    region: 'eu-west-1',
                    // endpoint: 'http://127.0.0.1:8002/',
                    endpoint: 'https://api.dev-helloself.com/partners-write/',
                },
                {
                    name: 'referral',
                    region: 'eu-west-1',
                    // endpoint: 'http://127.0.0.1:8011/',
                    endpoint: 'https://api.dev-helloself.com/referral/',
                },
                {
                    name: 'files',
                    region: 'eu-west-1',
                    // endpoint: 'http://127.0.0.1:8021/',
                    endpoint: 'https://api.dev-helloself.com/files/',
                },
                {
                    name: 'expert',
                    region: 'eu-west-1',
                    // endpoint: 'http://127.0.0.1:8003/',
                    endpoint: 'https://api.dev-helloself.com/expert/',
                },
                {
                    name: 'messaging-v2',
                    region: 'eu-west-1',
                    // endpoint: 'http://127.0.0.1:8023/',
                    endpoint: 'https://api.dev-helloself.com/messaging-v2/',
                },
                {
                    name: 'payments',
                    region: 'eu-west-1',
                    endpoint: 'https://api.dev-helloself.com/payments/',
                },
            ],
            cognito: {
                REGION: 'eu-west-1',
                USER_POOL_ID: 'eu-west-1_QTVBsPDPs',
                APP_CLIENT_ID: '3ljnp0m1fkhqnnv7ecovb00uf0',
                IDENTITY_POOL_ID: 'eu-west-1:bd38bf12-1fd9-4728-a9e2-4e383c758248',
            },
        };
}

export default config;
